import React, { useState, useEffect } from 'react'
import axios from 'axios'

import Loader from '../../Loader/Loader';
import './Clubs.css'

import ClubCard from './ClubCard'

const CLUB_URL = "/clubs"

function Clubs() {

  const [clubs, setClubs] = useState('')

  useEffect(() => {
    async function getClubs() {
      try {
        const response = await axios.get(process.env.REACT_APP_DEPT_API + CLUB_URL);
        setClubs(response.data);
      } catch (error) {
        console.error(error);
      }
    }
    getClubs()
  }, [])


  const sortedClubs = clubs && clubs.sort((a, b) => a.order_no < b.order_no ? -1 : 1)

  return (
    <div>
      <div className='section__container'>
        <div className='section'>
          <h1 className='section__header'>Student Clubs</h1>
          <p className='about__p'>
            The Department is home to various Technical Clubs, facilitating the development of technical and leadership skills. Students from all years are welcome and active members of the club, enabling them to find and receive or provide mentorship. They conduct workshops, hackathons and coding challenges, tech talks, and several other events, providing a platform for students to build connections and learn to collaborate while showcasing their technical flair.
          </p>
          <div className='clubs_container'>
            {sortedClubs ? sortedClubs.map((club) => (
              <ClubCard
                key={club._id}
                id={club._id}
                name={club.name}
                description={club.description}
                logo={club.logo && club.logo.url}
              />
            )) : <Loader color="#AE9142" size={70} />}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Clubs